import { FormControl } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { LangContext } from "../../contexts/LangContext";
import { api } from "../../services/api";
import SelectSys from "../selectSys";

export default function MultiSelectGroup({ handleSelected, id, ...props }) {
  const [optionsSelect, setOptionsSelect] = useState([]);
  const { lang } = useContext(LangContext);

  useEffect(() => {
    getGroups();
  }, []);
  const getGroups = async () => {
    const { data: list } = await api({ method: "GET", url: `/group/` });
    const listSelect = [];
    list.map((row) => {
      listSelect.push({ label: row.name, id: row.id });
    });
    setOptionsSelect(listSelect);
  };
  return (
    <FormControl size="medium" sx={{ width: "100%" }}>
      <SelectSys
        {...props}
        multiple
        variant="standard"
        options={optionsSelect}
        sx={{ width: "100%" }}
        onChange={(item, elemento) => {
          handleSelected(elemento);
        }}
        size="medium"
      />
    </FormControl>
  );
}
